import { toast } from "react-hot-toast";

const useToast = () => {
  const showSuccess = (message: string) => {
    toast.success(message, {
      duration: 3000,
      position: "top-right",
    });
  };

  const showError = (message: string) => {
    toast.error(message, {
      duration: 3000,
      position: "top-right",
    });
  };

  return { showSuccess, showError };
};

export default useToast;
